/**
 * AbortNotifier is a simplified implementation of AbortController,
 * made for use with older browsers which do not support AbortController.
 *
 * Once we drop support for those older browsers, this class should be deleted
 * and all usage migrated to use AbortController and AbortSignal.
 */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
export var AbortNotifier = /*#__PURE__*/ function() {
    "use strict";
    function AbortNotifier() {
        var _this = this;
        _class_call_check(this, AbortNotifier);
        this._aborted = false;
        this.listeners = [];
        this.abort = function(reason) {
            if (_this._aborted) {
                return;
            }
            _this._aborted = true;
            _this._reason = reason;
            _this.listeners.forEach(function(callback) {
                callback(reason);
            });
            _this.listeners = [];
        };
        this.addAbortListener = function(callback) {
            if (_this._aborted) {
                return;
            }
            _this.listeners.push(callback);
        };
    }
    _create_class(AbortNotifier, [
        {
            key: "aborted",
            get: function get() {
                return this._aborted;
            }
        },
        {
            key: "reason",
            get: function get() {
                return this._reason;
            }
        }
    ]);
    return AbortNotifier;
}();
